import gql from 'graphql-tag';

const GET_TRANSACTIONAL_MAIL = gql`
query getTransactionalMail ($id: String) {
    getTransactionalMail(id: $id) {
      name,
      items,
      amount,
      description,
      key
    }
}`;

export default GET_TRANSACTIONAL_MAIL;
